export const linkBuilderApi = {
    getLinkBuilder: 'v1/api/linkbuilder',
    createLinkBuilder: 'v1/api/linkbuilder',
    editLinkBuilder: 'v1/api/linkbuilder',
    deleteLinkBuilder: 'v1/api/linkbuilder',

    getIPWhitelist: 'v1/api/IPWhitelist',
    createIpWhiteList: 'v1/api/IPWhitelist',
    authTwofactor:'v1/api/auth/verify',
    editIpAddress: 'v1/api/IPWhitelist',
    deleteIpAddress : 'v1/api/IPWhitelist',
    getIPSearch: 'v1/api/IPWhitelist'

}
